export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Suche deine Lieferadresse',
      },
      placeholder: 'Deine Adresse eingeben',
    },
  },
  toasts: {
    failed_to_load_stores: 'Fehler beim Laden von Store, bitte aktualisiere die Seite',
  },
  errors: {
    no_delivery_companies: 'Lieferung für diese Adresse nicht verfügbar',
  },
};
